function Tag({ active = false, className = '', children, ...props }) {
  const stateClass = active
    ? 'border-[var(--accent-green)] bg-[var(--accent-green)] text-white'
    : 'border-[var(--accent-green)] bg-transparent text-[var(--accent-green)] hover:bg-[var(--accent-green)] hover:text-white';

  return (
    <button
      type="button"
      className={`rounded-md border px-3 py-2 text-sm transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-gold)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-primary)] ${stateClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Tag;
